import {React, useState, useEffect, useRef} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.css';
import Webcam from "react-webcam";
import './passport.css';
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';




const Idproofback = () => {
    const webcamRef = useRef(null);
    const [idimageSrc, setImageSrc] = useState(null);
	const [uploading, setUploading] = useState('');
    const navigate = useNavigate();
    const brandname = localStorage.getItem('brandname');
    const id_image = localStorage.getItem('id_image_back');
    const setdocumenttitle = localStorage.getItem('setdocumenttitle');
    const address_proof = localStorage.getItem('address_proof');
    const partial_page = localStorage.getItem('partial_page');
    const kyctype = localStorage.getItem('kyctype');
    const [isMobile, setIsMobile] = useState(false);

    const [info, setinfo] = useState({
        id: '',
        image: ''
    });

    let textMsg = '';

    const [disabledbtn, setdisabled] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selvisible, setSelvisible] = useState(true);

    const [btn, setbtn] = useState("btn btn-primary");
    const [btntxt, setbtntxt] = useState("Continue");
    const [btnicon, setbtnicon] = useState("fa-solid fa-arrow-right");

    const checkIfMobile = () => {
        if (window.innerWidth <= 768) {
          return true;
        }
        return false;
      };

      // Funzione per aggiornare lo stato isMobile
      const updateMedia = () => {
        setIsMobile(checkIfMobile());
      };

      // Aggiungi listener per il resize della finestra
      useEffect(() => {
        updateMedia();
        window.addEventListener('resize', updateMedia);
        return () => {
          window.removeEventListener('resize', updateMedia);
        };
      }, []);

    const getData = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        localStorage.setItem('Ip-Adrees', res.data.ip);
    };

    const retake = () => {
        setImageSrc(null);
        setSelvisible(true);
        setVisible(false);
        setdisabled(false);
        setbtntxt("Continue");
        setbtn("btn btn-primary");
        setbtnicon("fa-solid fa-arrow-right");
    }

    const capture = () => {
         const idimageSrc = webcamRef.current.getScreenshot({width: 720, height: 1280});
        setImageSrc(idimageSrc);
        setinfo({
            id: setdocumenttitle,
            image: idimageSrc
        });
        setSelvisible(false);
        setVisible(true);
    };
    // const nextPage = () => {
    //     navigate('/proof');
    // };
    const handleUpload = async (event) => {
		setUploading('Uploading...');
		event.currentTarget.disabled = true;
        setbtntxt("");
        setbtn("btn btn-success");
        setbtnicon("fa-solid fa-check");
        setdisabled(true);
        setTimeout(() => { setdisabled(false); }, 10000);
        await saveinStorage();
    };

	console.log(localStorage.getItem('passportPhoto'));

    const saveinStorage = async () => {
        let datas = JSON.stringify({
            "uuid": localStorage.getItem('uuid'),
            "image": info.image,
            "type": setdocumenttitle,
        });

        let config = {
            method: 'post',
            mode: 'cors',
            url: 'https://kyc2.codegotech.com/save_image',
            headers: {
                'Content-Type': 'application/json'
            },
            data: datas
        };

        axios.request(config).then((response) => {
            if (response.status === 200) {
                if (response.data.status === 1) {
                    if (kyctype === 'partial' && partial_page === 'ID') {
                        let data = JSON.stringify({
                            "type": setdocumenttitle,
                            "uuid": localStorage.getItem('uuid'),
                            "kyctype": kyctype,
                            "partial_page": partial_page,
                            "userAgent": localStorage.getItem('userAgent'),
                            "ip_address": localStorage.getItem('Ip-Adrees'),
                            "passportPhoto_back": response.data.image,
                            "passportPhoto": localStorage.getItem('passportPhoto'),
                        });
						console.log(data);
                        let config = {
                            method: 'post',
                            mode: 'cors',
                            url: 'https://kyc2.codegotech.com/send_userdata',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };

                        axios.request(config).then((response) => {
                            if (response.status === 200) {
                                localStorage.removeItem('userAgent');
                                localStorage.removeItem('Ip-Adrees');
                                localStorage.removeItem('passportphoto');
                                localStorage.removeItem('uuid');
                                navigate('/process');
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                    } else {
                        localStorage.setItem('passportPhoto_back', response.data.image);
                        if (address_proof === '1') {
                            navigate('/proof');
                        } else {
                            navigate('/Recognition');
                        }
                    }
                } else {
                    setVisible(false);
                    setSelvisible(true);
                    let html = 'Please re-upload passport image.';
                    let mrz_data_element = document.getElementById('mrz-data');
                    mrz_data_element.innerHTML = html;
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        let uuids = localStorage.getItem('uuid');
        if (uuids === null) {
            navigate('/');
        }
        getData();
    }, []);

    return (
        <>
            {!isMobile && <BrowserOnlyWarning />}
            {isMobile && (
                <KycShell step={2} brandName={brandname}>
                    <div className="kyc-card">
                        <div className="kyc-card__eyebrow">Capture document</div>
                        <h1 className="kyc-card__title">{setdocumenttitle} — back side</h1>
                        <p className="kyc-card__subtitle">
                            Make sure that all the information on the photo is visible,
                            easy to read and all corners are within the frame.
                        </p>

                        <div className="kyc-camera-wrap bg_camera proof">
                            {idimageSrc ? (
                                <img src={idimageSrc} alt="Captured" className="img-fluid" />
                            ) : (
                                <>
                                    <Webcam
                                         audio={false}
                                         ref={webcamRef}
                                         screenshotFormat="image/jpg"
                                         videoConstraints={{
                                            height: 720,
                                            width: 1280,
                                            facingMode: "environment"
                                         }}
                                         className="webcam proof"
                                         width={1280}
                                         height={720}
                                    />
                                    <div className="kyc-camera-overlay" />
                                    <div className="kyc-camera-hint">
                                        Align the back of your document
                                    </div>
                                    <button
                                        type="button"
                                        onClick={capture}
                                        className="kyc-capture-btn camera"
                                        aria-label="Capture"
                                    />
                                </>
                            )}
                        </div>

                        {idimageSrc && (
                            <>
                                {uploading && (
                                    <p style={{ color: 'var(--kyc-danger)', margin: 0, fontSize: 13, fontWeight: 500 }}>
                                        {uploading}
                                    </p>
                                )}
                                <div className="kyc-capture-actions">
                                    <button onClick={() => setImageSrc(null)} className="kyc-btn kyc-btn-secondary btn_retake">
                                        <i className="fa fa-repeat" aria-hidden="true"></i> Retake
                                    </button>
                                    <button onClick={handleUpload} disabled={!idimageSrc} className="kyc-btn kyc-btn-primary btn_retake upload">
                                        Submit <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        <div className="kyc-example">
                            {textMsg && (
                                <p style={{ color: 'var(--kyc-danger)', fontSize: 12, margin: '0 0 6px', fontWeight: 500 }}>{textMsg}</p>
                            )}
                            <p className="kyc-example__label">Example {setdocumenttitle}</p>
                            <img src={id_image} className="example_pic" alt="example" />
                        </div>

                        <div id='mrz-data' style={{ color: 'var(--kyc-danger)', fontSize: 13, fontWeight: 500 }} />
                    </div>
                </KycShell>
            )}
        </>
    );
}
export default Idproofback;
